<template>
    <div>
        <h3>Configurações e hierarquias de indústrias</h3>
        <ul>
            <li v-for="(first, f) in industry" :key="f">
                <input type="text" v-model="first.title">
                <i class="ico-delete color-red" @click="deleteItem([f])"></i>
                <button class="button button-small button-white white" type="button" @click="openForm(first)"><template v-if="first.photos">{{ first.photos.length }}</template><template v-else>0</template> <i class="ico-createmode_editedit"></i></button>
                <ul>
                    <li v-for="(second, s) in first.children" :key="s">
                        <input type="text" v-model="second.title">
                        <i class="ico-delete color-red" @click="deleteItem([f,s])"></i>
                        <button class="button button-small button-white white" type="button" @click="openForm(second)"><template v-if="second.photos">{{ second.photos.length }}</template><template v-else>0</template> <i class="ico-createmode_editedit"></i></button>
                        <ul>
                            <li v-for="(third, t) in second.children" :key="t">
                                <input type="text" v-model="third.title">
                                <i class="ico-delete color-red" @click="deleteItem([f,s,t])"></i>
                                <button class="button button-small button-white white" type="button" @click="openForm(third)"><template v-if="third.photos">{{ third.photos.length }}</template><template v-else>0</template> <i class="ico-createmode_editedit"></i></button>
                                <ul>
                                    <li v-for="(four, o) in third.children" :key="o">
                                        <input type="text" v-model="four.title">
                                        <i class="ico-delete color-red" @click="deleteItem([f,s,t,o])"></i>
                                        <button class="button button-small button-white white" type="button" @click="openForm(four)"><template v-if="four.photos">{{ four.photos.length }}</template><template v-else>0</template> <i class="ico-createmode_editedit"></i></button>
                                    </li>
                                    <li><a href="javascript:void(0)" @click="add([f,s,t])">Adicionar em {{ third.title }} (nvl 3)</a></li>
                                </ul>
                            </li>
                            <li><a href="javascript:void(0)" @click="add([f,s])">Adicionar em {{ second.title }} (nvl 2)</a></li>
                        </ul>
                    </li>
                    <li><a href="javascript:void(0)" @click="add([f])">Adicionar em {{ first.title }} (nvl 1)</a></li>
                </ul>
            </li>
            <li><a href="javascript:void(0)" @click="add([])">Adicionar na raíz (nvl 0)</a></li>
        </ul>
        <button class="button" type="button" @click="save()">Salvar</button>
        <modal :show="edit.show" v-model="edit.show">
            <div slot="body">
                <template v-if="edit.item">
                    <h3>{{ edit.item.title }}</h3>
                    <form-industry :snap="edit.item"></form-industry>
                </template>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '../../components/Modal'
import FormIndustry from './Form'

export default {
    name: "IndustryList",
    components: {
        Modal,
        FormIndustry
    },
    data(){
        return {
            loading: true,
            industry: [],
            snap: {},
            edit: {
                item: null,
                show: false
            }
        }
    },
    mounted(){
        this.load()
    },
    methods:{
        
        openForm(item){
            if(typeof item.photos == 'undefined' || !item.photos)
            item.photos = []
            this.edit.item = item
            setTimeout(() => {
                this.edit.show = true

            },300)
        },
        add(path){
            if(path.length == 0){
                console.log('adding to root...')
                this.industry.push({title: '', children: [], id: '', photos: []})
            }
            if(path.length == 1){
                console.log('adding to index '+ path[0] + '...')
                this.industry[path[0]].children.push({title: '', children: [], id: '', photos: []})
            }
            if(path.length == 2){
                console.log('adding to index '+ path[0] + ' > ' + path[1] + '...')
                this.industry[path[0]].children[path[1]].children.push({title: '', children: [], id: '', photos: []})
            }
            if(path.length == 3){
                console.log('adding to index '+ path[0] + ' > ' + path[1] + ' > ' + path[2] + '...')
                this.industry[path[0]].children[path[1]].children[path[2]].children.push({title: '', children: [], id: '', photos: []})
            }
            if(path.length == 4){
                this.industry[path[0]].children[path[1]].children[path[2]].children[path[3]].children.push({title: '', id: '', photos: []})
            }
        },
        deleteItem(path){
            console.log(path)
            if(path.length == 1){
               this.industry.splice(path[0],1)
            }
            if(path.length == 2){
                let obj = this.industry[path[0]].children
                obj.splice(path[1],1)
            }
            if(path.length == 3){
                let obj = this.industry[path[0]].children[path[1]].children
                obj.splice(path[2],1)
            }
            if(path.length == 4){
                let obj = this.industry[path[0]].children[path[1]].children[path[2]].children
                obj.splice(path[3],1)            }
            if(path.length == 5){
                let obj = this.industry[path[0]].children[path[1]].children[path[2]].children[path[3]].children
                obj.splice(path[4],1)   }
        },
        load(){
            this.loading = true
            this.$db.collection("industries").get().then((snap) => {
                let slide = {}
                this.loading = true
                snap.forEach((doc) => {
                    let data = doc.data()
                    data.docId = doc.id
                    slide = data
                });
                this.snap = slide
                this.industry = this.snap.industry || []
                this.loading = false
            })
        },
        save(){
            const form = {
                docId: this.snap.docId,
                industry: this.industry
            }
            this.$db.collection("industries").doc(this.snap.docId).set(form).then(
                () => {
                    // if(result){
                        this.$root.updated = false
                        this.$root.alerts.push({msg: 'Slide salvo com sucesso', type: 'success'})
                        this.callback()
                    // }
                    
                },
                err => {
                    this.$root.updated = false
                    alert('Erro ao salvar: ' + err)

                }
            );
        }
    }
}
</script>